import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import { PartImportApi } from "src/api/generated/erp/parts/partImport/partImportApi.ts";
import { FormSelectField } from "src/components/common/forms/fields/FormSelectField.tsx";
import i18n from "i18next";
import { FormSingleFileInputField } from "src/components/common/forms/fields/FormSingleFileInputField.tsx";
import { uploadFile } from "src/utils/fileUploading.ts";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { requireRule } from "src/components/common/forms/validation.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface PartImportViewProps extends FormCommonProps<void> {}

interface FormValues {
	file: File;
	numberSequenceId: number;
}

export const PartImportView = (props: PartImportViewProps) => {
	const { onCompleted, onFormEdited } = props;

	return (
		<AsyncForm
			fetch={() => PartImportApi.getFormInitData()}
			getDefaultValues={() => ({})}
			submit={submit}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.parts.partImport.form"),
			}}
			render={({ control, data: { numberSequenceOptions } }) => (
				<>
					<FormSelectField
						name="numberSequenceId"
						control={control}
						label={i18n.t("number_sequence")}
						options={numberSequenceOptions}
						getOptionKey={(o) => o.numberSequenceId}
						getOptionLabel={(o) => o.sequenceName}
						rules={requireRule()}
					/>
					<FormSingleFileInputField control={control} name={"file"} label={i18n.t("file")} />
				</>
			)}
		/>
	);
	async function submit({ file, numberSequenceId }: FormValues) {
		const fileHandle = await uploadFile(file);
		await PartImportApi.importParts({
			fileHandle: fileHandle,
			partNoNumberSequenceId: numberSequenceId,
		});
	}
};
